export default {
    ACCEPT_OFFER: "acceptOffer",
    CHANGE_CREDIT_LIMIT: "changeCreditLimit",
    INIT_CREDIT_LIMIT_CHANGE: "initCreditLimitChange",
    FINISH_APPLY: "finishApply",
    PATCH: "patch",
    RESTART_APPLY: "restartApply",
    RESUME: "resume",
    RESUME_CASCADE_ACTION: "resume_cascade_action",
    START_APPLY: "startApply",
    SUBMIT_ANSWERS: "submitAnswers",
    SUBMIT_COMPLETE: "submitComplete",
    SUBMIT_ESIGN: "submitEsign",
    SELECT_PAYMENT_PLAN: "selectPaymentPlan",
    SUBMIT_BANK_ACCOUNT: "submitBankAccount",
    SUBMIT_BANK_CARD: "submitBankCard",
    SUBMIT_FULL_APPlY: "submitFullApply",
    SUBMIT_PREQUALIFLY: "submitPrequalify",
    SUBMIT_PRESCREEN: "submitPrescreen",
    PROVE_SEND_SMS: "proveSendSms",
    PROVE_RESEND_SMS: "proveResendSms",
    PROVE_SMS_STATUS: "proveSmsStatus",
    PROVE_VERIFICATION_RESULT: "proveVerificationResult",
}
